import React from 'react';
import { Box, Typography } from '@mui/material';

const UnityCatalogDashboard: React.FC = () => (
  <Box sx={{ p: 4, textAlign: 'center', color: '#64748b' }}>
    <Typography variant="h6">Unity Catalog Dashboard — coming soon</Typography>
  </Box>
);

export default UnityCatalogDashboard;
